"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeStr = normalizeStr;
function normalizeStr(text) {
    return text
        .normalize('NFD')
        .toLowerCase()
        .replace(/[\u0300-\u036f]/g, '');
}
